resortModule.directive('spinner', ['$http', function($http) {
    return {
        restrict: 'E',
        scope: {
            shouldspin : '=',
        },
        templateUrl: 'templates/general/spinner.html',
    };
}]);